module.exports = "<h1 matDialogTitle>{{confirmHead}}</h1>\r\n<div mat-dialog-content>{{confirmMessage}}</div>\r\n<div mat-dialog-actions class=\"pt-24 btn\">\r\n    <button mat-raised-button class=\"mat-accent mr-16\" (click)=\"dialogRef.close(true)\">\r\n        {{confirmOkText}}\r\n    </button>\r\n    <button mat-button (click)=\"dialogRef.close(false)\">\r\n        {{confirmCancelText}}\r\n    </button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/core/components/confirm-dialog/confirm-dialog.component.html
// module id = ../../../../../src/app/core/components/confirm-dialog/confirm-dialog.component.html
// module chunks = main